export const convertRemToPixels = (rem: number) => {
  if (rem < 0) return NaN
  return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
}
